import React from 'react';

type Faq = {
  question: string;
  answer: JSX.Element;
};

const EVENT_ITEMS = [
  'Festival Opening Ceremony',
  'Festival Closing Ceremony',
  'World Premiere of Top Gun: Maverick featuring Tom Cruise, Miles Teller, and Jon Hamm, directed by Joseph Kosinski',
  'World Premiere of Elvis starring Tom Hanks, Directed by Baz Luhrmann',
  'World Premiere of Three Thousand Years of Longing starring Idris Elba and Tilda Swinton, Directed by George Miller',
  'Additional exclusive film premieres, VIP parties, and red carpet events',
  'Brut exclusive programming throughout the festival',
];

const CANNES_FAQS: Faq[] = [
  {
    question: 'How do I get invited to the Red Carpet?',
    answer: (
      <>
        <p className="leading-relaxed">
          Owners of the Producer Pass NFT will be granted unprecedented access
          to the Cannes Film Festival including VIP invitations to attend the
          following events:
        </p>
        <ul className="ml-4 mt-6 list-disc leading-relaxed">
          {EVENT_ITEMS.map((eventItem) => (
            <li key={eventItem}>{eventItem}</li>
          ))}
        </ul>
      </>
    ),
  },
  {
    question: 'Why are these tokens non-transferrable?',
    answer: (
      <p className="leading-relaxed">
        The tokens are non-transferrable by default to ensure every person can
        redeem for red carpet access fairly, and no one will accidentally
        purchase a NFT on secondary when it is no longer valid for redemption.
        These NFTs can be made transferrable post red carpet ticket redemption.
      </p>
    ),
  },
  {
    question: 'What is this fund?',
    answer: (
      <p className="leading-relaxed">
        This Annenberg Inclusion Initiative Accelerator program is dedicated to
        support female filmmakers in the industry. The fund will be stored on
        Endaoment.org, a well known, reputable charity 501(c)(3) service that
        allows cryptocurrency donations.
      </p>
    ),
  },
];

const FAQ = ({question, answer}: Faq) => {
  return (
    <div className="mb-12">
      <h3 className="mb-4 text-xl font-semibold text-white sm:text-2xl">
        {question}
      </h3>
      <div>{answer}</div>
    </div>
  );
};

const FaqSection = () => {
  return (
    <div className="mt-24">
      <div className="mb-10 sm:mb-12">
        <h2 className="text-3xl font-semibold text-white sm:text-4xl">FAQs</h2>
        <div className="mt-2 h-px bg-gradient-to-r from-white"></div>
      </div>

      {CANNES_FAQS.map(({question, answer}) => {
        return <FAQ key={question} question={question} answer={answer} />;
      })}
    </div>
  );
};

export default FaqSection;
